const TicketStepLineChart = (data = [
  { name: 'Visited Event Page', value: 1000, color: '#8DAA5B' },
  { name: 'Registered', value: 600, color: '#4C4C87' },
  { name: 'Booked Tickets', value: 350, color: '#F26430' },
  { name: 'Attended', value: 300, color: '#5A9BD4' }
]) => ({
  tooltip: {
    trigger: 'axis',
    formatter: params => {
      const point = params[0];
      return `<b>${point.name}</b><br/>👥 ${point.value} users`;
    }
  },
  grid: {
    left: 45,
    right: 30,
    bottom: 50,
    top: 45
  },
  xAxis: {
    type: 'category',
    data: data.map(d => d.name),
    axisTick: { show: false },
    axisLine: { show: false },
    axisLabel: { show: false }
  },
  yAxis: {
    type: 'value',
    name: 'Users'
  },
  series: [
    {
      name: 'Users',
      type: 'line',
      step: 'middle',
      data: data.map(d => ({
        value: d.value,
        itemStyle: { color: d.color }
      })),
      lineStyle: {
        color: '#B0BEC5', // neutral gray line
        width: 3
      },
      symbol: 'circle',
      symbolSize: 10,
      label: {
        show: true,
        position: 'top',
        formatter: '{c}'
      }
    }
  ]
});

export default TicketStepLineChart;
